import { Injectable } from '@angular/core'
import { environment } from 'src/environments/environment'
import axios from 'axios'
import { AuthService } from 'src/app/shared/services/auth.service'
@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private nameURL: string = 'user'
  private token = ''
  constructor(private AuthService: AuthService) {
    this.token = this.AuthService.getLogin()
  }

  Login(body: any) {
    return axios
      .post(`${environment.apiurl}/${this.nameURL}/login`, body, {
      })
      .then((res) => res.data)
      .catch((err) => {
        throw err.response.data
      })

  }
  permiss(token: string) {
    return axios
      .get(`${environment.apiurl}/${this.nameURL}/role/permissions`, {
        headers: { Authorization: 'Bearer ' + token },
      })
      .then((res) => res.data)
      .catch((err) => {
        throw err.response.data
      })

  }
}
